import { IPlanDetails } from "../interfaces/interfaces";

export const categories = [
  { label: "ID document", value: "id_document" },
  { label: "Application fee", value: "application_fee" },
  { label: "Proof of income (Payslips)", value: "payslip" },
  { label: "Bank statements", value: "bank_statement" },
  { label: "Signed Lease", value: "lease_signed" },
  { label: "Profile Picture", value: "profile_picture" }
];

export const pricing = [
  { plan: "Basic Plan", price: "99" },
  { plan: "Premium Plan", price: "199" },
  { plan: "Premium Plus Plan", price: "250" }
];

export const PROPERTY_STATUS = [
  { name: "Vacant", value: "vacant" },
  { name: "Occupied", value: "occupied" },
  { name: "Under maintenance", value: "under_maintenance" },
  { name: "Closed", value: "closed" },
  { name: "Sold", value: "sold" }
];

export const rentalStatus = [
  { name: "New", value: "new" },
  { name: "Processing", value: "processing" },
  { name: "Waiting Documents", value: "waiting_documents" },
  { name: "Active", value: "active" },
  { name: "Approved", value: "approved" },
  { name: "Rent Due", value: "rent_due" },
  { name: "Expired", value: "expired" },
  { name: "Balance Due", value: "balance_due" },
  { name: "Eviction", value: "eviction" }
];

export const ONBOARDING_SUBMISSION_STATUS = [
  { name: "Awaiting Review", value: "awaiting_review" },
  { name: "Submitted", value: "submitted" },
  { name: "Under Review", value: "under_review" },
  { name: "Agreed", value: "agreed" },
  { name: "Awaiting Payment", value: "awaiting_payment" },
  { name: "Active", value: "active" },
  { name: "Rejected", value: "rejected" }
];

export const USER_STATUS = [
  { name: "New", value: "new" },
  { name: "Active", value: "active" },
  { name: "Pending plan payment", value: "pending_plan_payment" },
  { name: "Suspended", value: "suspended" },
  { name: "Archived", value: "archived" },
  { name: "On hold", value: "on_hold" },
  { name: "Awaiting Review", value: "awaiting_review" },
  { name: "Under Review", value: "under_review" },
  { name: "Awaiting Payment", value: "awaiting_payment" }
];

export const MAINTENANCE_STATUS = [
  { name: "New", value: "new" },
  { name: "In progress", value: "in_progress" },
  { name: "Resolved", value: "resolved" },
  { name: "Closed", value: "closed" }
];

export const REQUEST_DEMO_STATUS = [
  { name: "New", value: "new" },
  { name: "Contacted", value: "contacted" },
  { name: "Demo Scheduled", value: "demo-scheduled" },
  { name: "Negotiation", value: "negotiation" },
  { name: "Follow-Up", value: "follow-up" },
  { name: "Closed - Won", value: "won" },
  { name: "Closed - Lost", value: "lost" }
];

export const SUPPORT_STATUS = [
  { name: "New", value: "new" },
  { name: "In progress", value: "in_progress" },
  { name: "Awaiting feedback", value: "awaiting-feedback" },
  { name: "Follow-Up", value: "follow-up" },
  { name: "Resolved", value: "resolved" },
  { name: "Closed", value: "closed" }
];

export const RENTAL_APPLICATION_ID_TYPE = [
  { name: "National ID", value: "national_id" },
  { name: "Passport", value: "passport" }
];

export const RENTAL_APPLICATION_EMPLOYMENT_STATUS = [
  { name: "Full time", value: "full_time" },
  { name: "Part time", value: "part_time" },
  { name: "Contract", value: "contract" },
  { name: "Self employed", value: "self_employed" },
  { name: "Unemployed", value: "unemployed" },
  { name: "Retired", value: "retired" },
  { name: "Student", value: "student" }
];

// Named periods the API understands for its two date filters. Same names on both
// sides so the query string in a link is the same thing the dropdown shows.
export const PAID_DATE_RANGES = [
  { name: "This month", value: "this_month" },
  { name: "Last 3 months", value: "last_3_months" },
  { name: "Last 6 months", value: "last_6_months" },
  { name: "Last 12 months", value: "last_12_months" },
  { name: "This year", value: "this_year" }
];

// What kind of invoice a row is. Stored on the invoice rather than guessed from
// its description, because it decides who is allowed to mark it paid.
export const INVOICE_TYPES = [
  { name: "Rent", value: "rent" },
  { name: "Plan", value: "plan" },
  { name: "Commission", value: "commission" },
  { name: "Other", value: "other" }
];

// Kinds an agency may settle itself. The two left out — plan and commission —
// are what RentalEase bills the agency and its sales users, so an agency marking
// one paid would be writing off a bill it owes rather than collecting one it is
// owed. Mirrors AGENCY_MAY_NOT_SETTLE in lib/helpers/invoice_types.py, which is
// where it is actually enforced.
export const AGENCY_SETTLEABLE_TYPES = ["rent", "other"];

// The kinds an agency can raise. Plan and commission are left out: those are
// what RentalEase bills the agency and its sales users, and the API refuses them
// on this route.
export const AGENCY_INVOICE_TYPES = [
  { name: "Rent", value: "rent" },
  { name: "Other", value: "other" }
];

// Unpaid and past its due date. Deliberately not a status: nothing carries
// status='overdue' until the monthly sweep stamps it, so filtering on the status
// showed an empty list for most of the month while the dashboard card — which
// works it out from the date — read thousands.
export const INVOICE_DUE_FILTER = [{ name: "Past due only", value: "true" }];

export const INVOICE_STATUS = [
  { name: "Pending", value: "pending" },
  // The tenant has paid by EFT and attached proof. Still unpaid — it is a claim
  // waiting on a person, which is why it is a state and not a flag.
  { name: "Awaiting approval", value: "awaiting-approval" },
  { name: "Paid", value: "paid" },
  { name: "Failed", value: "failed" },
  { name: "Overdue", value: "overdue" },
  { name: "Cancelled", value: "cancelled" }
];

export const LEAD_TYPES = [
  { name: "Management", value: "management" },
  { name: "Buy", value: "buy" },
  { name: "Rent", value: "rent" },
  { name: "Other", value: "other" }
];

export const LEAD_SUBTYPES = [
  { name: "Inquiry", value: "inquiry" },
  { name: "Request Demo", value: "request-demo" },
  { name: "Callback Request", value: "callback" },
  { name: "Consultation", value: "consultation" },
  { name: "Pricing Request", value: "pricing_request" },
  { name: "Sales Request", value: "sales_request" },
  { name: "Other", value: "other" }
];

export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const ADMIN_ROLES = [
  {
    label: "Super Admin",
    role: "super-admin",
    value: 1
  },
  {
    label: "Admin",
    role: "admin",
    value: 2
  }
];

export const ROLES = [
  {
    label: "Super Admin",
    role: "super-admin",
    value: 1
  },
  {
    label: "Admin",
    role: "admin",
    value: 2
  },
  {
    label: "Account Admin",
    role: "account-admin",
    value: 3
  },
  {
    label: "Account User",
    role: "account-user",
    value: 4
  },
  {
    label: "Tenant",
    role: "tenant",
    value: 5
  }
];

// Plans

export const PLAN_DETAILS: IPlanDetails[] = [
  {
    id: 1,
    plan: "starter",
    plan_code: "",
    price: 0,
    value: [
      {
        feature: "property-groups",
        limit: 1
      },
      {
        feature: "properties",
        limit: 5
      },
      {
        feature: "account-users",
        limit: 1
      },
      {
        feature: "active-listings",
        limit: 1
      },
      {
        feature: "featured-listings",
        limit: 0
      },
      {
        feature: "rentals-portal",
        isAllowedFeature: false
      },
      {
        feature: "rental-application-portal",
        isAllowedFeature: false
      },
      {
        feature: "tenants-portal",
        isAllowedFeature: false
      },
      {
        feature: "maintenance-portal",
        isAllowedFeature: false
      },
      {
        feature: "expenses-portal",
        isAllowedFeature: false
      }
    ]
  },
  {
    id: 2,
    plan: "premium",
    price: 0,
    plan_code: "",
    value: [
      {
        feature: "property-groups",
        limit: 3
      },
      {
        feature: "properties",
        limit: 20
      },
      {
        feature: "account-users",
        limit: 3
      },
      {
        feature: "active-listings",
        limit: 15
      },
      {
        feature: "featured-listings",
        limit: 5
      },
      {
        feature: "rentals-portal",
        isAllowedFeature: true
      },
      {
        feature: "rental-application-portal",
        isAllowedFeature: true
      },
      {
        feature: "tenants-portal",
        isAllowedFeature: true
      },
      {
        feature: "maintenance-portal",
        isAllowedFeature: true
      },
      {
        feature: "expenses-portal",
        isAllowedFeature: true
      }
    ]
  },
  {
    id: 3,
    plan: "enterprise",
    price: 0,
    plan_code: "PLN_jnnlqxrurplv5vf",
    value: [
      {
        feature: "property-groups",
        limit: -1
      },
      {
        feature: "properties",
        limit: -1
      },
      {
        feature: "account-users",
        limit: -1
      },
      {
        feature: "active-listings",
        limit: 20
      },
      {
        feature: "featured-listings",
        limit: 5
      },
      {
        feature: "rentals-portal",
        isAllowedFeature: true
      },
      {
        feature: "rental-application-portal",
        isAllowedFeature: true
      },
      {
        feature: "tenants-portal",
        isAllowedFeature: true
      },
      {
        feature: "maintenance-portal",
        isAllowedFeature: true
      },
      {
        feature: "expenses-portal",
        isAllowedFeature: true
      }
    ]
  },
  {
    id: 4,
    plan: "enterprise-plus",
    price: 0,
    plan_code: "",
    value: [
      {
        feature: "property-groups",
        limit: -1
      },
      {
        feature: "properties",
        limit: -1
      },
      {
        feature: "account-users",
        limit: -1
      },
      {
        feature: "active-listings",
        limit: -1
      },
      {
        feature: "featured-listings",
        limit: -1
      },
      {
        feature: "rentals-portal",
        isAllowedFeature: true
      },
      {
        feature: "rental-application-portal",
        isAllowedFeature: true
      },
      {
        feature: "tenants-portal",
        isAllowedFeature: true
      },
      {
        feature: "maintenance-portal",
        isAllowedFeature: true
      },
      {
        feature: "expenses-portal",
        isAllowedFeature: true
      }
    ]
  },
  {
    id: 5,
    plan: "basic-listing",
    price: 0,
    plan_code: "",
    value: [
      {
        feature: "property-groups",
        limit: 1
      },
      {
        feature: "properties",
        limit: 10
      },
      {
        feature: "account-users",
        limit: 1
      },
      {
        feature: "active-listings",
        limit: 3
      },
      {
        feature: "featured-listings",
        limit: 1
      },
      {
        feature: "rentals-portal",
        isAllowedFeature: false
      },
      {
        feature: "rental-application-portal",
        isAllowedFeature: false
      },
      {
        feature: "tenants-portal",
        isAllowedFeature: false
      },
      {
        feature: "maintenance-portal",
        isAllowedFeature: false
      },
      {
        feature: "expenses-portal",
        isAllowedFeature: false
      }
    ]
  },
  {
    id: 6,
    plan: "pro-listing",
    price: 0,
    plan_code: "",
    value: [
      {
        feature: "property-groups",
        limit: 1
      },
      {
        feature: "properties",
        limit: 20
      },
      {
        feature: "account-users",
        limit: 1
      },
      {
        feature: "active-listings",
        limit: 10
      },
      {
        feature: "featured-listings",
        limit: 2
      },
      {
        feature: "rentals-portal",
        isAllowedFeature: false
      },
      {
        feature: "rental-application-portal",
        isAllowedFeature: false
      },
      {
        feature: "tenants-portal",
        isAllowedFeature: false
      },
      {
        feature: "maintenance-portal",
        isAllowedFeature: false
      },
      {
        feature: "expenses-portal",
        isAllowedFeature: false
      }
    ]
  }
];

export const PLANS = [
  { name: "Starter", value: 1 },
  { name: "Premium", value: 2 },
  { name: "Enterprise", value: 3 },
  { name: "Enterprise Plus", value: 4 },
  { name: "Basic Listing", value: 5 },
  { name: "Pro Listing", value: 6 }
];

export const PRIORITY = [
  { name: "Low", value: "low" },
  { name: "Medium", value: "medium" },
  { name: "High", value: "high" },
  { name: "Urgent", value: "urgent" }
];

export const VIEWEDBY = [
  { name: "Landlord only", value: "landlord-only" },
  { name: "Landlord and tenant", value: "landlord-tenant" }
];

export const PROPERTY_TYPE = [
  { name: "Apartment", value: "apartment" },
  { name: "House", value: "house" },
  { name: "Commercial", value: "commercial" },
  { name: "Land", value: "land" },
  { name: "Other", value: "other" }
];

export const CATEGORY = [
  { name: "Rent", value: "rent" },
  { name: "For sale", value: "for_sale" }
];

export const ENTITY_TYPE = [
  { name: "Property", value: "property" },
  { name: "Property Group", value: "property_group" },
  { name: "Users", value: "user" }
];

export const EVENT_ACTION = [
  { name: "Created", value: "create" },
  { name: "Updated", value: "update" }
];

export const EXPENSE_CATEGORIES = [
  { name: "Advertising", value: "advertising" },
  { name: "Agent fees", value: "agent_fees" },
  { name: "Cleaning Fees", value: "cleaning_fees" },
  { name: "Legal Fees", value: "legal_fees" },
  { name: "Electricity", value: "electricity" },
  { name: "Rent", value: "rent" },
  { name: "Water", value: "water" },
  { name: "Property tax", value: "property_tax" },
  { name: "Mortgage", value: "mortgage" },
  { name: "Insurance", value: "insurance" },
  { name: "Bank fees", value: "bank_fees" },
  { name: "Maintenance", value: "maintenance" },
  { name: "Repairs", value: "repairs" },
  { name: "Other", value: "other" }
];

export const EXPENSE_STATUS = [
  { name: "New", value: "new" },
  { name: "Cancelled", value: "cancelled" },
  { name: "Pending approval", value: "pending_approval" },
  { name: "Approved", value: "approved" },
  { name: "Rejected", value: "rejected" }
];

export const EXPENSE_FREQUENCY = [
  { name: "Daily", value: "daily" },
  { name: "Weekly", value: "weekly" },
  { name: "Monthly", value: "monthly" },
  { name: "Quarterly", value: "quarterly" },
  { name: "Annually", value: "annually" }
];

export type CurrencyType = "USD" | "ZAR" | "EUR" | "GBP" | "TZS";

export const conversionRates = {
  USD: 1,
  ZAR: 19,
  EUR: 0.92,
  GBP: 0.79,
  TZS: 2600
};

export const currencySymbols = {
  USD: "$",
  ZAR: "R",
  EUR: "€",
  GBP: "£",
  TZS: "Tsh"
};

export const DISCOUNT_PERCENTAGE = 6;

export const availableRates = {
  ZAR: 19,
  USD: 1
};

export const RENTAL_APPLICATION_SAMPLE_DATA = {
  first_name: "John",
  last_name: "Doe",
  email: "lehramaano+ra@gmail.com",
  phone: "0715123456",
  alternate_phone: "0715123457",
  id_type: "national_id",
  id_number: "8837893738",
  date_of_birth: "1988-11-21T00:00:00",
  address: "",
  unit: "",
  street_address: "125 Dallas avenue",
  suburb: "Menlyn",
  city: "Pretoria",
  emergency_contact_name: "Julie",
  emergency_contact_relationship: "Sister",
  emergency_contact_phone: "0715123458",
  emergency_contact_email: "lehramaano+ra2@gmail.com",
  employment_status: "full_time",
  employer_name: "MTN",
  employer_address: "125 Dallas avenue",
  employer_phone: "0715123459",
  employer_email: "lehramaano+ra3@gmail.com",
  job_title: "Accountant",
  employment_start_date: "2022-11-21T00:00:00",
  supervisor_name: "Martin",
  supervisor_phone: "0715123450",
  monthly_gross_income: 18000,
  monthly_net_income: 15000,
  other_income_source: "Investments",
  other_income_amount: 2000,
  total_monthly_income: 17000,
  bank_name: "Absa",
  bank_account_number: "543218123",
  bank_branch: "Sandton",
  bank_account_type: "Cheque",
  current_landlord_name: "Milton",
  current_landlord_phone: "0715123451",
  current_landlord_email: "lehramaano+ra4@gmail.com",
  current_rent_amount: 7000,
  current_move_in_date: "2026-11-21T00:00:00",
  reason_for_leaving: "Moving jobs",
  desired_move_in_date: "2026-11-21T00:00:00",
  desired_lease_term: 12,
  number_of_occupants: 2,
  has_pets: false,
  pet_details: "",
  has_vehicles: true,
  vehicle_details: "2 vehicles",
  number_of_vehicles: 2,
  id_document:
    "https://dev.api.rentalease.vertexease.com/files/other/4f717e9461364e6ba346db9e2939f70b.pdf",
  proof_of_income:
    "https://dev.api.rentalease.vertexease.com/files/other/4f717e9461364e6ba346db9e2939f70b.pdf",
  bank_statements:
    "https://dev.api.rentalease.vertexease.com/files/other/4f717e9461364e6ba346db9e2939f70b.pdf",
  employment_letter:
    "https://dev.api.rentalease.vertexease.com/files/other/4f717e9461364e6ba346db9e2939f70b.pdf",
  terms_accepted: true,
  terms_accepted_date: "2026-11-21T00:00:00",
  signature: "JD"
};

// Role ids, as the API defines them. Named here because the UI compares against
// these numbers in a dozen places and a bare 7 tells the next reader nothing.
export const ROLE = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  // The agency owner. Shown as "Agency owner" — it used to be labelled Landlord,
  // which now means something else.
  AGENCY_OWNER: 3,
  ACCOUNT_USER: 4,
  TENANT: 5,
  SALES: 6,
  // A client of the agency who owns properties it manages.
  AGENCY_LANDLORD: 7
};
